import type CanvasProperties from "./Canvas.properties.ts";
import type { MarketComponentMarketComponentIO } from "../../generated/fresh-guard-api";
import { useEditMarket } from "../../provider/edit-market/EditMarket.hook.ts";

export const useCanvasController = (props: CanvasProperties) => {
  const { enableDragAndDropMarketArea } = useEditMarket();

  const handleRightClickOpenDetails = (
    event: MouseEvent | TouchEvent,
    marketComponent: MarketComponentMarketComponentIO,
  ) => {
    event.preventDefault();
    props.handleDialogOpenDetails(marketComponent);
  };

  const handleRightClickOpenEdit = (
    event: MouseEvent | TouchEvent,
    marketComponent: MarketComponentMarketComponentIO,
  ) => {
    event.preventDefault();

    if (props.handleDialogOpenEdit) {
      props.handleDialogOpenEdit(marketComponent);
    }
  };

  return {
    handleRightClickOpenDetails,
    handleRightClickOpenEdit,
    enableDragAndDropMarketArea,
  };
};
